import { createApp } from 'vue'
import App from './App.vue'
import router from './router'  // 引入路由
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 侧栏/顶栏样式必须在 EP 之后引入，否则会被 EP 菜单默认样式覆盖
import '@/styles/zone-sidebar.css'
import '@/styles/zone-header.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'  // 引入所有图标
import axios from 'axios'
import { resolveTenantCodeForRequest } from '@/config/instanceDefaults'

// 忽略 ResizeObserver 循环告警（弹窗/表格等布局变化时常见无害报错，避免 dev overlay 遮挡）
;(function () {
  const origOnError = window.onerror
  window.addEventListener('error', (e) => {
    if (e.message && (e.message.includes('ResizeObserver loop') || e.message.includes('undelivered notifications'))) {
      e.stopImmediatePropagation()
      e.preventDefault()
    }
  }, true)
  window.onerror = function (msg, source, lineno, colno, error) {
    if (typeof msg === 'string' && (msg.includes('ResizeObserver loop') || msg.includes('undelivered notifications'))) return true
    return origOnError ? origOnError.call(this, msg, source, lineno, colno, error) : false
  }
})()

const app = createApp(App)
// 注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 配置 Axios 默认基础地址（需在 mount 前设置）
// 部署时使用相对路径，通过 nginx 代理到后端
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || ''
axios.defaults.withCredentials = true // 携带 cookie，配合后端 Session 登录
axios.interceptors.request.use((config) => {
  config.headers = config.headers || {}
  const hdrs = config.headers
  const code = resolveTenantCodeForRequest()
  if (code) {
    hdrs['X-Tenant-Code'] = code
  }
  const existing =
    (typeof hdrs.get === 'function' && hdrs.get('Cache-Control')) ||
    hdrs['Cache-Control'] ||
    hdrs['cache-control']
  if (existing == null || String(existing).trim() === '') {
    if (typeof hdrs.set === 'function') {
      hdrs.set('Cache-Control', 'no-cache')
      hdrs.set('Pragma', 'no-cache')
    } else {
      hdrs['Cache-Control'] = 'no-cache'
      hdrs['Pragma'] = 'no-cache'
    }
  }
  return config
})
app.config.globalProperties.$axios = axios

// 使用路由和 Element Plus
app.use(router)
app.use(ElementPlus)
app.mount('#app')